import { render, staticRenderFns } from "./WorkoutPlanCopyDialog.vue?vue&type=template&id=a24e77f0"
import script from "./WorkoutPlanCopyDialog.vue?vue&type=script&lang=js"
export * from "./WorkoutPlanCopyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports